import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../Shared/Services/shared.service';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  readonly APIurl = environment.apiUrl;
  constructor(private http: HttpClient, private shared: SharedService) { }

  GetAgentInfo() {
    return this.http.get(`${this.APIurl}/UserInfo/GetAgentInfo`, this.shared.options);
  }

  ChangePassword(data: any) {
    return this.http.post(`${this.APIurl}/UserInfo/ChangePassword`, data, this.shared.options);
  }

  UpdateAgentInfo(data: any) {
    return this.http.post(`${this.APIurl}/UserInfo/UpdateAgentInfo`, data, this.shared.options);
  }

  CreateNewAgent(agent: any) {
    return this.http.post(`${this.APIurl}/UserInfo/CreateNewAccount`, agent, this.shared.options);
  }

  GetProgramUserData(currentPage: number, pageSize: number) {
    return this.http.get(`${this.APIurl}/UserInfo/GetProgramUserData?currentPage=${currentPage}&pageSize=${pageSize}`, this.shared.options);
  }

  GetNumberOfUsers() {
    return this.http.get(`${this.APIurl}/UserInfo/GetNumberOfUsers`, this.shared.options);
  }

  GetAllLoggedInUsers(id?: any) {
    return this.http.get(`${this.APIurl}/UserInfo/GetAllLoggedInUsers?agentId=${id}`, this.shared.options);
  }

  GetUserData(userId: any) {
    return this.http.get(`${this.APIurl}/UserInfo/GetUserData?id=${userId}`, this.shared.options);
  }

  CreateNewUser(data: any) {
    return this.http.post(`${this.APIurl}/UserInfo/CreateLoggedInUser`, data, this.shared.options);
  }

  EditUser(data: any) {
    return this.http.post(`${this.APIurl}/UserInfo/EditLoggedInUser`, data, this.shared.options);
  }

  DeleteUser(id: any) {
    return this.http.get(`${this.APIurl}/UserInfo/DeleteUser?Id=${id}`, this.shared.options);
  }
}
